import React, { useState, useEffect } from 'react';

function TextViewer({ filePath, fileName }) {
    const [text, setText] = useState('');

    useEffect(() => {
        const loadTxtFile = async () => {
            if (filePath) {
                try {
                    const result = await fetch(filePath);
                    const txtContent = await result.text();
                    setText(txtContent);
                } catch (error) {
                    console.error('Error loading TXT file:', error);
                }
            }
        };

        loadTxtFile();
    }, [filePath]);

    return (
        <div>
            {filePath && (
                <div style={{ marginTop: 10 }}>
                    <a href={filePath} download target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#007bff' }}>
                        ⬇️ Download Arquivo - {fileName}
                    </a>
                </div>
            )}
            <pre>{text}</pre>
        </div>
    );
}

export default TextViewer;
